var _path, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 113,
    viewBox: "0 0 121 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.667 13.4806L69.7022 4.91561C58.1077 1.80886 49.5379 6.78891 46.4209 18.4216L35.8641 57.8201C32.696 69.6435 37.6686 78.0887 49.2631 81.1955L81.2282 89.7605C93.0096 92.9173 101.348 88.0387 104.516 76.2154L115.073 36.8168C118.19 25.1841 113.449 16.6375 101.667 13.4806Z",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.3155 24.2694L71.5374 18.434C63.6379 16.3174 57.7992 19.7103 55.6756 27.6358L48.4831 54.4784C46.3247 62.5337 49.7126 68.2876 57.612 70.4042L79.3901 76.2396C87.4169 78.3904 93.0979 75.0666 95.2563 67.0112L102.449 40.1686C104.572 32.2431 101.342 26.4202 93.3155 24.2694Z",
    fill: "#39B93A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1",
    maskUnits: "userSpaceOnUse",
    x: 0.990723,
    y: 20.1392,
    width: 93,
    height: 93,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.990723,
    y: 20.1392,
    width: 93,
    height: 93
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.138 21.1392H27.7498C12.3489 21.1392 1.99072 31.9516 1.99072 48.034V85.1507C1.99072 101.188 12.3489 112 27.7498 112H67.138C82.5389 112 92.8516 101.188 92.8516 85.1507V48.034C92.8516 31.9516 82.5389 21.1392 67.138 21.1392Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.138 21.1392H27.7498C12.3489 21.1392 1.99072 31.9516 1.99072 48.034V85.1507C1.99072 101.188 12.3489 112 27.7498 112H67.138C82.5389 112 92.8516 101.188 92.8516 85.1507V48.034C92.8516 31.9516 82.5389 21.1392 67.138 21.1392Z",
    fill: "#72DC60",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.138 22.1392C67.6903 22.1392 68.138 21.6914 68.138 21.1392C68.138 20.5869 67.6903 20.1392 67.138 20.1392V22.1392ZM67.138 20.1392C66.5857 20.1392 66.138 20.5869 66.138 21.1392C66.138 21.6914 66.5857 22.1392 67.138 22.1392V20.1392ZM67.138 20.1392H27.7498V22.1392H67.138V20.1392ZM27.7498 20.1392C19.8065 20.1392 13.0957 22.933 8.37274 27.864C3.65332 32.7912 0.990723 39.776 0.990723 48.034H2.99072C2.99072 40.2096 5.5072 33.747 9.81708 29.2474C14.1234 24.7515 20.2921 22.1392 27.7498 22.1392V20.1392ZM0.990723 48.034V85.1507H2.99072V48.034H0.990723ZM0.990723 85.1507C0.990723 93.3867 3.65377 100.36 8.37316 105.281C13.096 110.206 19.8066 113 27.7498 113V111C20.2921 111 14.1231 108.388 9.81666 103.897C5.50675 99.4029 2.99072 92.9517 2.99072 85.1507H0.990723ZM27.7498 113H67.138V111H27.7498V113ZM67.138 113C75.0814 113 81.7811 110.206 86.4928 105.28C91.2007 100.359 93.8516 93.3854 93.8516 85.1507H91.8516C91.8516 92.9529 89.3462 99.4042 85.0475 103.898C80.7527 108.388 74.5955 111 67.138 111V113ZM93.8516 85.1507V48.034H91.8516V85.1507H93.8516ZM93.8516 48.034C93.8516 39.7773 91.2012 32.7925 86.4932 27.8649C81.7814 22.9332 75.0814 20.1392 67.138 20.1392V22.1392C74.5955 22.1392 80.7524 24.7513 85.0471 29.2465C89.3458 33.7457 91.8516 40.2084 91.8516 48.034H93.8516Z",
    fill: "url(#paint1_linear)",
    mask: "url(#path-3-outside-1)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0286 81.3249C41.011 81.3249 39.9933 80.9388 39.2164 80.1619L28.4358 69.3813C26.8821 67.8275 26.8821 65.3107 28.4358 63.7615C29.9895 62.2078 32.5018 62.2033 34.0555 63.757L42.0286 71.73L60.7823 52.9763C62.336 51.4226 64.8483 51.4226 66.402 52.9763C67.9558 54.53 67.9558 57.0469 66.402 58.6006L44.8407 80.1619C44.0639 80.9388 43.0462 81.3249 42.0286 81.3249Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.0286 81.3249C41.011 81.3249 39.9933 80.9388 39.2164 80.1619L28.4358 69.3813C26.8821 67.8275 26.8821 65.3107 28.4358 63.7615C29.9895 62.2078 32.5018 62.2033 34.0555 63.757L42.0286 71.73L60.7823 52.9763C62.336 51.4226 64.8483 51.4226 66.402 52.9763C67.9558 54.53 67.9558 57.0469 66.402 58.6006L44.8407 80.1619C44.0639 80.9388 43.0462 81.3249 42.0286 81.3249Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4358 63.7615L28.577 63.9031L28.5772 63.9029L28.4358 63.7615ZM42.0286 71.73L41.8872 71.8714L42.0286 72.0129L42.17 71.8714L42.0286 71.73ZM66.402 58.6006L66.2606 58.4592L66.402 58.6006ZM44.8407 80.1619L44.9822 80.3033L44.8407 80.1619ZM42.0286 81.1249C41.0616 81.1249 40.0955 80.7582 39.3579 80.0205L39.075 80.3033C39.8911 81.1194 40.9603 81.5249 42.0286 81.5249V81.1249ZM39.3579 80.0205L28.5772 69.2398L28.2944 69.5227L39.075 80.3033L39.3579 80.0205ZM28.5772 69.2398C27.1015 67.7641 27.1018 65.3741 28.577 63.9031L28.2946 63.6199C26.6624 65.2473 26.6627 67.891 28.2944 69.5227L28.5772 69.2398ZM28.5772 63.9029C30.0531 62.427 32.4388 62.4231 33.9141 63.8984L34.197 63.6156C32.5648 61.9834 29.9259 61.9886 28.2944 63.6201L28.5772 63.9029ZM33.9141 63.8984L41.8872 71.8714L42.17 71.5886L34.197 63.6156L33.9141 63.8984ZM42.17 71.8714L60.9237 53.1177L60.6409 52.8349L41.8872 71.5886L42.17 71.8714ZM60.9237 53.1177C62.3993 51.6421 64.785 51.6421 66.2606 53.1177L66.5435 52.8349C64.9116 51.2031 62.2727 51.2031 60.6409 52.8349L60.9237 53.1177ZM66.2606 53.1177C67.7362 54.5934 67.7362 56.9836 66.2606 58.4592L66.5435 58.742C68.1753 57.1102 68.1753 54.4667 66.5435 52.8349L66.2606 53.1177ZM66.2606 58.4592L44.6993 80.0205L44.9822 80.3033L66.5435 58.742L66.2606 58.4592ZM44.6993 80.0205C43.9616 80.7582 42.9956 81.1249 42.0286 81.1249V81.5249C43.0969 81.5249 44.1661 81.1194 44.9822 80.3033L44.6993 80.0205Z",
    fill: "url(#paint3_linear)",
    fillOpacity: 0.5,
    mask: "url(#path-5-inside-2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 33.8452,
    y: 3.81689,
    width: 83.2397,
    height: 87.0621,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b",
    x: -23.0093,
    y: -3.86084,
    width: 140.861,
    height: 140.861,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd",
    x: 12.2705,
    y: 36.811,
    width: 70.2968,
    height: 59.5139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.454902 0 0 0 0 0.870588 0 0 0 0 0.376471 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 120.009,
    y1: 18.3952,
    x2: 50.2992,
    y2: 61.0595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BF763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26AB5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 16.4543,
    y1: 31.7246,
    x2: 74.4139,
    y2: 103.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 64.7103,
    y1: 57.1407,
    x2: 19.8646,
    y2: 59.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 31.6114,
    y1: 61.7115,
    x2: 65.828,
    y2: 61.9694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.2450fde65d8f474eb04332217e30fecb.svg";
export { ForwardRef as ReactComponent };